var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.084 4.62489C8.97307 -1.98089 0.177734 -0.371559 0.177734 6.99267C0.177734 12.5071 6.52996 17.5556 7.34262 18.2387C8.38667 19.1176 9.70756 19.5995 11.0723 19.5995C12.437 19.5995 13.7579 19.1176 14.802 18.2387C15.6137 17.5562 21.8637 12.5007 21.904 7.05222C21.9555 0.0839972 12.9197 -2.47712 11.084 4.62489Z",
    fill: "url(#paint0_linear_4513_3024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4513_3024",
    x1: 11.0408,
    y1: 19.0311,
    x2: 11.0408,
    y2: -0.168892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF3333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f9a9bd14b7d67fb20cc0ce0e3507e470.svg";
export { ForwardRef as ReactComponent };